import { useQuery } from "@tanstack/react-query";
import axiosAuth from "../../axiosAuth";
import { GET_INVENTORY_STATUS_BY_ID } from "../apiRoutes";
import { useEffect } from "react";

export interface InventoryStatusItem {
  _id: string;
  packingStatus: string;
  approvedBy: string;
  shipmentDate: string;
  isDeleted?: boolean;
  inventoryCheckLists: string[];
}

export interface InventoryStatusNoteDetail {
  _id: string;
  schoolId: string;
  note: string;
  createdBy: string;
  lastUpdatedBy: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
}

export interface ApprovedByDetail {
  _id: string;
  profile_id: string;
  name: string;
  role: string[];
}

export interface InventoryStatusDetailApi {
  _id: string;
  schoolId: string;
  inventoryStatusList: InventoryStatusItem[];
  inventoryChecklistDetails: any;
  note?: string | null;
  createdBy: string;
  lastUpdatedBy: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
  inventoryStatusNoteDetails: InventoryStatusNoteDetail[];
  approvedByDetails: ApprovedByDetail[];
}

export interface InventoryStatusDetailResponse {
  status: number;
  error: boolean;
  count: number;
  issues: any[];
  data: InventoryStatusDetailApi | null;
  message: string;
}

export const useGetInventoryStatusDetailBySchoolIdQuery = (schoolId: string) => {
  return useQuery({
    queryKey: ["schoolInventoryStatusDetail", schoolId],
    enabled: !!schoolId, // ✅ automatically runs when schoolId is ready
    queryFn: async () => {
      const res = await axiosAuth.get<InventoryStatusDetailResponse>(
        `${GET_INVENTORY_STATUS_BY_ID}${schoolId}/`
      );
      return res.data;
    },
    refetchOnMount: true, // ✅ ensures refetch when coming back to route
    refetchOnWindowFocus: false,
  });
};


